<template>
	<v-container fluid>
		<div v-if="!loading">
			<v-row justify="end">
                <information :text="`${text[locale.split('-')[0]]}`"/>
            </v-row>
			<!--table head-->
			<v-divider color="black"/>
			<v-row class="subtitle-2" no-gutters>
				<v-col class="text-left"></v-col>
				<v-col v-for="(item, i) in headers" :key="i"
					class="text-pre-wrap"
					:class="item.style">
					{{ `${item.title}` | localize }}
				</v-col>
			</v-row>
			<v-divider color="black"/>
			<!--media tab-->
			<div v-if="media?.length">
				
				<div v-for="item in media" :key="item.id" class="body-2">
					<v-row class="my-1">
						<v-col class="text-left">{{'Media costs' | localize }}, $</v-col>
						<v-col class="text-center">{{ item.smm_cost }}</v-col>
						<v-col class="text-center">{{ item.content_ads_cost }}</v-col>
						<v-col class="text-center">{{ item.bloggers_influencers_cost }}</v-col>
						<v-col class="text-center">{{ item.banner_ads_cost }}</v-col>
						<v-col class="text-center">{{ item.postal_cost }}</v-col>
						<v-col class="text-center">{{ formatNumber(item.outdoor_advertising_cost) }}</v-col>
						<v-col class="text-center">{{ formatNumber(item.autoradio_podcasts_cost) }}</v-col>
						<v-col class="text-center">{{ formatNumber(item.tv_cost) }}</v-col>
					</v-row>
					<v-divider />

					<v-row class="my-1">
						<v-col class="text-left">{{ 'Media coverage'| localize }}</v-col>
						<v-col class="text-center">{{ item.smm_coverage * 100 }}%</v-col>
						<v-col class="text-center">{{ item.content_ads_coverage * 100}}%</v-col>
						<v-col class="text-center">{{ item.bloggers_influencers_coverage * 100 }}%</v-col>
						<v-col class="text-center">{{ item.banner_ads_coverage * 100 }}%</v-col>
						<v-col class="text-center">{{ item.postal_coverage * 100 }}%</v-col>
						<v-col class="text-center">{{ item.outdoor_advertising_coverage * 100 }}%</v-col>
						<v-col class="text-center">{{ item.autoradio_podcasts_coverage * 100 }}%</v-col>
						<v-col class="text-center">{{ item.tv_coverage * 100 }}%</v-col>
					</v-row>
					<v-divider />
				</div>
			</div>
		</div>
		<v-row v-else justify="center" class="mt-12">
			<loader />
		</v-row> 
	</v-container>
</template>
<script>
import { localeNumber } from '../../../functions/common';
import Information from '../../../layouts/Information.vue';
import Loader from '../../../layouts/Loader.vue';

	export default {
		data (){
			return {
				headers: [
					{ title: 'SMM (impression)', style: 'text-center' },
					{ title: 'Content Ads (impression)', style: 'text-center' },
					{ title: 'Bloggers & influencers (impression)', style: 'text-center' },
					{ title: 'Banner ads (impression)', style: 'text-center' },
					{ title: 'Postal (mail)', style: 'text-center' },
					{ title: 'Outdoor Ads (campaign)', style: 'text-center' },
					{ title: 'Autoradio podcasts (campaign)', style: 'text-center' },
					{ title: 'TV (campaign)', style: 'text-center' },
				],
				text: {
					en: 'The media report summarises the advertising costs for each advertising channel and outlines the peak market coverage achieved by each channel.',
					ro: 'Raportul media prezintă costurile de publicitate pentru fiecare canal publicitar și evidențiază acoperirea maximă a pieței atinsă de fiecare canal.',
					ru: 'В отчете для СМИ приведены данные о расходах на рекламу по каждому рекламному каналу, а также указана максимальный охват аудитории, достигнутая каждым из них.'
				}
			}
		},		
		computed: {
			loading () {
				return this.$store.getters.loading
			},
			locale() {
				return this.$store.getters.locale;
			},
			game() {
				return this.$store.getters.game
			},
			media() {
				return this.$store.getters.media;
			},
		},
		methods: {
			//format in numeral
			formatNumber (param) {
				return localeNumber(param, this.locale)
			},
		},
		components: { Information, Loader },
		async mounted() {
			
			if (this.game && this.game.round > 0) {

				const obj = {
					gameId: this.game.id,
					round: this.game.round - 1,
				}

				/*  the last year media fetching  ****/
				try {
					await this.$store.dispatch('fetchMedia', obj);
				} catch (error) {
					await this.$store.dispatch('setError', error.message)
				}
			}
		}
	}	
</script>
